import { createClient } from '@/shared/api';
import type {
  GetUnreviewedReportByIdQuery,
  GetUnreviewedReportByIdQueryVariables,
} from '@/shared/api';
import GET_UNREVIEWED_REPORT_BY_ID from '../queries/getUnreviewedReportById';

/**
 * Loads one unreviewed report for the inbox review flow. Runs the getUnreviewedReportById query and throws the returned message unless it reports success, otherwise yielding the report.
 *
 * @param input - Query input identifying the unreviewed report.
 * @returns A promise resolving to the unreviewed report.
 */
const fetchGetUnreviewedReportById = async (
  input: GetUnreviewedReportByIdQueryVariables['input'],
): Promise<NonNullable<GetUnreviewedReportByIdQuery['getUnreviewedReportById']>['report']> => {
  const client = createClient();
  const result = await client.query<
    GetUnreviewedReportByIdQuery,
    GetUnreviewedReportByIdQueryVariables
  >({
    query: GET_UNREVIEWED_REPORT_BY_ID,
    variables: {
      input,
    },
  });
  const { data } = result;
  // API always returns this field for a resolved query; code already accessed it unconditionally.
  const { getUnreviewedReportById } = data;
  if (!getUnreviewedReportById!.isSuccess) {
    throw new Error(getUnreviewedReportById!.message ?? undefined);
  }
  return getUnreviewedReportById!.report;
};

export default fetchGetUnreviewedReportById;
